var isProperty = require('is-property');

var gen = function gen(obj, prop) {
  return isProperty(prop) ? obj + '.' + prop : obj + '[' + JSON.stringify(prop) + ']';
};

gen.valid = isProperty;

gen.property = function (prop) {
  return isProperty(prop) ? prop : JSON.stringify(prop);
};

module.exports = gen;